import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { AccountService } from '../../account/account.service';
import { AuthService } from '../../auth/auth.service';
import { BrandService } from '../../brand/brand.service';
import { ProcessService } from '../../process/process.service';
import { UserService } from '../../user/user.service';
import { User } from '../../user/user';
import { Process } from '../../process/process';
import { Config } from '../../config/env.config';
import { AppModalService } from '../../modal/modal.service';
import { BRAND_CHOOSE_MODAL_NAME } from '../../modal/modal-names';
import { getUserInitials, getUserFullName } from '../../user/user-helpers';
import { PermissionsService } from '../../permissions/permissions.service';


@Component({
  moduleId: module.id,
  selector: 'account-dropdown',
  templateUrl: 'account-dropdown.component.html',
  styleUrls: ['account-dropdown.component.scss']
})
export class AccountDropdownComponent implements OnInit, OnDestroy {

  @Input() color: string = 'darkred';
  @Input() disabled: boolean = false;

  userModel: any = {};
  user: User;
  processes: Array<Process>;
  hasMultipleAvaliableBrands: boolean = false;
  helpLink: string = Config.DEFAULT_SUPPORT_URL;

  @Output() userRefreshed = new EventEmitter();

  private notificationsSub: Subscription;

  constructor(
    private account: AccountService,
    private authService: AuthService,
    private brandService: BrandService,
    private userService: UserService,
    private processService: ProcessService,
    private toastrService: ToastrService,
    private router: Router,
    private modalService: AppModalService,
    protected permissionsService: PermissionsService,
  ) { }

  // getters
  get withAvatar(): boolean {
    return this.userModel.avatar !== null;
  }

  get withProgress(): boolean {
    return this.userModel.progress > 0;
  }

  get withTasks(): boolean {
    return this.userModel.currentTasks
           && this.userModel.currentTasks.length > 0;
  }

  get userInitials(): string|null {
    return getUserInitials(this.user);
  }

  get userFullName(): string|null {
    return getUserFullName(this.user);
  }

  get userType(): string {
    return this.permissionsService.hasPermission('admin') ? 'Admin' : '';
  }

  get hasCatalogPermission(): boolean {
    return this.permissionsService.hasPermission(['admin', 'catalog-edit']);
  }

  // hooks
  ngOnInit() {
    this.user = new User();
    this.userService.getUser()
      .subscribe(user => {
        this.user = user;
        this.userRefreshed.emit();
      });

    this.processes = [];

    // show/hide 'Change brands' menu item
    this.brandService.getBrandList()
    .subscribe(brands => {
      this.hasMultipleAvaliableBrands = brands ? brands.length > 1 : false;
    });

    this.userModel = this.account.userModel;

    this.account.getUser();
    this.account.getCurrentTasks();
  }

  ngOnDestroy() {
    if (this.notificationsSub) { this.notificationsSub.unsubscribe(); }
  }

  // handlers
  onLogoutClick() {
    this.router.navigate(['/logout']);
  }

  onGlobalCatalogClick() {
    this.router.navigate(['/global-brand-information/product-groups']);
  }

  onAccountSettingsClick() {
    this.router.navigate(['/account-information']);
  }

  onChangeBrandClick() {
    this.modalService.showModal(BRAND_CHOOSE_MODAL_NAME);
  }

}
